// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__1OXIn","input":"Form_input__270go","btn":"Form_btn__2dolM"};